/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the highest percentage difference two numbers can have?`)
};

const es_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la mayor diferencia porcentual que pueden tener dos números?`)
};

const de_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hoch kann der prozentuale Unterschied zwischen zwei Zahlen höchstens sein?`)
};

const nl_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het hoogste percentageverschil dat twee getallen kunnen hebben?`)
};

const fr_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence en pourcentage maximale que peuvent avoir deux nombres ?`)
};

const it_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza percentuale massima che due numeri possono avere?`)
};

const pt_br2_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a maior diferença percentual que dois números podem ter?`)
};

const pt_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a maior diferença percentual que dois números podem ter?`)
};

const ja_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値のパーセントの差の最大値はどれくらいですか？`)
};

const zh_pct_difference_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个数的百分比差异最高能达到多少？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_faq4_q", locale)
	if (locale === "en") return en_pct_difference_faq4_q(inputs)
	if (locale === "es") return es_pct_difference_faq4_q(inputs)
	if (locale === "de") return de_pct_difference_faq4_q(inputs)
	if (locale === "nl") return nl_pct_difference_faq4_q(inputs)
	if (locale === "fr") return fr_pct_difference_faq4_q(inputs)
	if (locale === "it") return it_pct_difference_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_faq4_q(inputs)
	if (locale === "pt") return pt_pct_difference_faq4_q(inputs)
	if (locale === "ja") return ja_pct_difference_faq4_q(inputs)
	return zh_pct_difference_faq4_q(inputs)
};